import { render, staticRenderFns } from "./MetricsCard.vue?vue&type=template&id=f575a268&scoped=true"
import script from "./MetricsCard.vue?vue&type=script&lang=js"
export * from "./MetricsCard.vue?vue&type=script&lang=js"
import style0 from "./MetricsCard.vue?vue&type=style&index=0&id=f575a268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f575a268",
  null
  
)

export default component.exports